import { environment } from "@environments/environment";

export const assetScriptUrl = environment.ASSETS_ENDPOINT + '/assets/scripts/';

const constants = {
  fieldAccessJson: 'fields-access.json',
  userActionAccessJson: 'action-access.json',
  pageAccessJson: 'page-access.json',

  fieldAccessList: ['hide', 'edit', 'view'],
  pageAccessList: ['create', 'add', 'edit', 'view']
};

export const accessControlConstants = constants;
